<template>
  <div class="d-flex align-items-start">
    <context-menu ref="context">
      <b-button v-for="(menu, index) in contextMenus" :key="index" block
        class="text-left mb-0 px-3 d-flex align-items-center"
        :variant="selectedMenu.url === menu.url ? 'primary' : 'light'" @click="handleSelectMenu(menu)">
        <b-icon class="mr-2" :icon="menu.icon" />
        {{ menu.name }}
      </b-button>
    </context-menu>
    <b-card class="w-100 min-h-62 mobile-transparent">
      <router-view></router-view>
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedMenu: {},
      contextMenus: [
        {
          url: "/my-enterprise/human-resources/jobs-position",
          icon: "person-badge-fill",
          name: "Organograma",
        },
        {
          url: "/my-enterprise/human-resources/employees/list",
          icon: "people",
          name: "Gestores Estratégicos",
        },
        {
          url: "/my-enterprise/human-resources/benefits",
          icon: "wallet2",
          name: "Benefícios",
        },
        {
          url: "/my-enterprise/human-resources/payment",
          icon: "cash",
          name: "Folha de pagamento",
        },
        {
          url: "/my-enterprise/human-resources/sesmet",
          icon: "droplet-half",
          name: "Segurança e med do trabalho",
        },
        {
          url: "/my-enterprise/human-resources/caged",
          icon: "wallet-fill",
          name: "E-Social (CAGED)",
        },
      ],
    };
  },
  methods: {
    handleSelectMenu(menu) {
      if (this.selectedMenu.url === menu.url) {
        this.$refs.context.close();
        return;
      }
      this.$refs.context.close();
      this.selectedMenu = menu;
      this.$router.push(menu.url);
    },
  },
  created() {
    this.selectedMenu.url = this.$route.fullPath;
  },
};
</script>
